<div [formGroup]="form" class="py-2">
  <div class="flex justify-between gap-4 items-center">
    <mat-form-field
      class="input-tg mt-message-input w-3/12"
      appearance="outline"
    >
      <mat-label>Nome</mat-label>
      <input matInput formControlName="name" />
    </mat-form-field>

    <mat-form-field
      class="input-tg mt-message-input w-3/12"
      appearance="outline"
    >
      <mat-label>Email</mat-label>
      <input matInput formControlName="email" />
    </mat-form-field>

    <mat-form-field
      class="input-tg mt-message-input w-2/12"
      appearance="outline"
    >
      <mat-label>Telefone</mat-label>
      <input matInput formControlName="phone" [mask]="'(99) 99999-9999'" />
    </mat-form-field>

    <!--    <mat-form-field-->
    <!--      class="input-tg mt-message-input w-2/12"-->
    <!--      appearance="outline"-->
    <!--    >-->
    <!--      <mat-label>Data nascimento</mat-label>-->
    <!--      <input matInput formControlName="birth" />-->
    <!--    </mat-form-field>-->

    <mat-form-field
      class="input-tg mt-message-input w-2/12"
      appearance="outline"
    >
      <mat-label>Data nascimento</mat-label>
      <input
        matInput
        [matDatepicker]="birth"
        (focus)="openDatepicker()"
        formControlName="birth"
        [max]="maxDate"
      />
      <mat-datepicker-toggle
        matIconSuffix
        [for]="birth"
      ></mat-datepicker-toggle>
      <mat-datepicker #birth></mat-datepicker>
    </mat-form-field>

    <button mat-flat-button class="btn-tg w-1/12" (click)="cancel()">
      Cancel
    </button>
    @if (this.editItem.idCreate != undefined) {
      <button
        mat-flat-button
        class="btn-tg w-1/12"
        [disabled]="form.invalid || loading"
        (click)="editAddress()"
      >
        @if (loading) {
          <mat-spinner
            diameter="22"
            class="loading-spinner"
            selected-track-color="red"
          ></mat-spinner>
        } @else {
          Editar
        }
      </button>
    } @else {
      <button
        mat-flat-button
        class="btn-tg w-1/12"
        [disabled]="form.invalid || loading"
        (click)="createAddress()"
      >
        @if (loading) {
          <mat-spinner
            diameter="22"
            class="loading-spinner"
            selected-track-color="red"
          ></mat-spinner>
        } @else {
          Adicionar
        }
      </button>
    }
  </div>
</div>
